export default defineNuxtRouteMiddleware(async (to) => {
  if (import.meta.client) return;
  if (!to.name?.toString().includes("research-topics-rtId")) return;

  const { rtId, rtSlug } = to.params;
  const researchTopicId = Number(rtId);
  if (isNaN(researchTopicId)) {
    return createError({
      statusCode: 404,
      statusMessage: "Invalid Research Topic ID"
    });
  }

  const { getResearchTopicBasicInfo } = useMongoDbService();
  const researchTopic = await getResearchTopicBasicInfo(researchTopicId);

  if (researchTopic === null) {
    return createError({
      statusCode: 404,
      statusMessage: `Research Topic ID ${researchTopicId} not found`
    });
  } else if (researchTopic.IsMagazinePage) {
    return navigateTo(
      {
        path: `/research-topics/${researchTopic.ResearchTopicId}/${researchTopic.Slug}/magazine`,
        query: to.query
      },
      {
        redirectCode: 301
      }
    );
  }

  let redirectionPath!: string;

  if (typeof rtSlug === "string" && rtSlug) {
    const rtPages = ["overview", "articles", "authors", "impact"];

    if (rtPages.includes(rtSlug)) {
      redirectionPath = `/research-topics/${researchTopic.ResearchTopicId}/${
        researchTopic.Slug
      }${rtSlug === "overview" ? "" : "/" + rtSlug}`;
    } else if (
      rtSlug !== researchTopic.Slug ||
      to.name.toString().includes("-overview")
    ) {
      redirectionPath = `/research-topics/${researchTopic.ResearchTopicId}/${researchTopic.Slug}`;
    }
  } else {
    redirectionPath = `/research-topics/${researchTopic.ResearchTopicId}/${researchTopic.Slug}`;
  }

  if (redirectionPath) {
    return navigateTo(
      {
        path: redirectionPath,
        query: to.query
      },
      {
        redirectCode: 301,
        replace: true
      }
    );
  }
});
